import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    langStates:'zh',
    token: localStorage.getItem("token")
  },
  mutations: {
    updateLang(state,lang){
      state.langStates = lang
    },
    updateToken(state,t){
      state.token = t
    }
  },
  actions: {
  },
  modules: {
  }
})
